// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cursor-toggle[data-v-76ee91a0]{left:-2px;position:relative}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/board/BoardToolsToggleCursor.vue"],"names":[],"mappings":"AACA,gCAEE,SAAA,CADA,iBACF","sourcesContent":["\n.cursor-toggle {\n  position: relative;\n  left: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
